module.exports = __webpack_public_path__ + "img/video.71d47ada.svg";